import React from "react";
// javascript plugin used to create scrollbars on windows
import { Route, Switch } from "react-router-dom";

import Navigation from "../components/Navbars/Navigation";
import routes from "routes.js";
import { Container } from "reactstrap";
const img = require("assets/img/17545.jpg");

class Auth extends React.Component {
  constructor(props) {
    super(props);        
  }  


  render() {
    return (
      <div>
        <div style={{height:"100vh", backgroundImage:"url(" + (img)+ ")"}}>
          <Navigation />
            <Container className="margin-auth">
              <Switch >
                  {routes.map((prop, key) => {
                      return (
                      <Route
                          path={prop.layout + prop.path}
                          component={prop.component}
                          key={key}
                      />
                      );
                  })}
              </Switch>
            </Container>
        </div>        
      </div>
    );
  }
}

export default Auth;
